import { useState } from 'react'
import Header from './Header'
import './ContactForm.css'
import './LandingPage.css'

const ContactForm = () => {
  /* servicesDropdownRef and isServicesDropdownOpen moved to Header component */
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    whereAreYouBased: '',
    email: '',
    whereDidYouFindMe: '',
    businessName: '',
    businessDescription: '',
    whyWorkWithMe: '',
    estimatedBudget: '',
    projectDeadline: ''
  })

  const [errors, setErrors] = useState<{ email?: string }>({})

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    if (errors[e.target.name as keyof typeof errors]) {
      setErrors({ ...errors, [e.target.name]: undefined })
    }
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    
    // Regular expression for robust email validation
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    if (!emailRegex.test(formData.email)) {
      setErrors({ email: 'Please enter a valid email address.' })
      return
    }

    setErrors({})
    // Form submission logic will be implemented later
    console.log('Form data:', formData)
  }

  /* Services dropdown state and effects moved to Header component */

  return (
    <div className="contact-form-wrapper">
      <Header />

      {/* Enquiry Form Hero Section */}
      <section className="enquiry-hero-section">
        <div className="enquiry-hero-content">
          <h1 className="enquiry-hero-headline">
            LET'S MAKE YOUR BRAND UNFORGETTABLE
          </h1>
          <div className="enquiry-hero-subheadline">
            <p className="enquiry-hero-script">Hey there! Excited to see you.</p>
            <div className="enquiry-hero-glasses">
              <img src="/icons BCS-24.svg" alt="Glasses icon" className="enquiry-glasses-icon" />
            </div>
          </div>
          <div className="enquiry-hero-description">
            <p>If you're ready to turn your business into a bold, head-turning brand (or give it the glow-up it's been quietly asking for), you're in the right place.</p>
            <p>This form helps us get a clear picture of your vision, your goals, and what you need, so we can show up ready to create magic. Take your time, share what you can, and don't worry about perfection — we'll handle the rest.</p>
            <p>Let's make your brand unforgettable. Fill out the form below and we'll be in touch soon!</p>
          </div>
        </div>
        <div className="enquiry-hero-speech">
          <img src="/icons BCS-35.svg" alt="Speech bubble icon" className="enquiry-speech-icon" />
        </div>
      </section>

      {/* Bold Ideas Banner Section */}
      <section className="bold-ideas-banner-section">
        <div className="bold-ideas-banner-icon">
          <img src="/icons BCS-25.svg" alt="Megaphone icon" className="bold-ideas-megaphone-icon" />
        </div>
        <div className="bold-ideas-banner-container">
          <div className="bold-ideas-banner-track">
            <div className="bold-ideas-banner-item">
              <img src="/submark%20socials@4x.png" alt="Bold Ideas Logo" className="bold-ideas-logo" />
              <p className="bold-ideas-text">Turning Bold Ideas Into Reality</p>
            </div>
            <div className="bold-ideas-banner-item">
              <img src="/submark%20socials@4x.png" alt="Bold Ideas Logo" className="bold-ideas-logo" />
              <p className="bold-ideas-text">Turning Bold Ideas Into Reality</p>
            </div>
            <div className="bold-ideas-banner-item">
              <img src="/submark%20socials@4x.png" alt="Bold Ideas Logo" className="bold-ideas-logo" />
              <p className="bold-ideas-text">Turning Bold Ideas Into Reality</p>
            </div>
            <div className="bold-ideas-banner-item">
              <img src="/submark%20socials@4x.png" alt="Bold Ideas Logo" className="bold-ideas-logo" />
              <p className="bold-ideas-text">Turning Bold Ideas Into Reality</p>
            </div>
            <div className="bold-ideas-banner-item">
              <img src="/submark%20socials@4x.png" alt="Bold Ideas Logo" className="bold-ideas-logo" />
              <p className="bold-ideas-text">Turning Bold Ideas Into Reality</p>
            </div>
            <div className="bold-ideas-banner-item">
              <img src="/submark%20socials@4x.png" alt="Bold Ideas Logo" className="bold-ideas-logo" />
              <p className="bold-ideas-text">Turning Bold Ideas Into Reality</p>
            </div>
            {/* Duplicate items for seamless loop */}
            <div className="bold-ideas-banner-item">
              <img src="/submark%20socials@4x.png" alt="Bold Ideas Logo" className="bold-ideas-logo" />
              <p className="bold-ideas-text">Turning Bold Ideas Into Reality</p>
            </div>
            <div className="bold-ideas-banner-item">
              <img src="/submark%20socials@4x.png" alt="Bold Ideas Logo" className="bold-ideas-logo" />
              <p className="bold-ideas-text">Turning Bold Ideas Into Reality</p>
            </div>
            <div className="bold-ideas-banner-item">
              <img src="/submark%20socials@4x.png" alt="Bold Ideas Logo" className="bold-ideas-logo" />
              <p className="bold-ideas-text">Turning Bold Ideas Into Reality</p>
            </div>
            <div className="bold-ideas-banner-item">
              <img src="/submark%20socials@4x.png" alt="Bold Ideas Logo" className="bold-ideas-logo" />
              <p className="bold-ideas-text">Turning Bold Ideas Into Reality</p>
            </div>
            <div className="bold-ideas-banner-item">
              <img src="/submark%20socials@4x.png" alt="Bold Ideas Logo" className="bold-ideas-logo" />
              <p className="bold-ideas-text">Turning Bold Ideas Into Reality</p>
            </div>
            <div className="bold-ideas-banner-item">
              <img src="/submark%20socials@4x.png" alt="Bold Ideas Logo" className="bold-ideas-logo" />
              <p className="bold-ideas-text">Turning Bold Ideas Into Reality</p>
            </div>
          </div>
        </div>
      </section>

      {/* Enquiry Form Section */}
      <section className="enquiry-form-section">
        <form className="enquiry-form" onSubmit={handleSubmit}>
          <div className="enquiry-form-row">
            <div className="enquiry-form-group">
              <label htmlFor="firstName">First Name:</label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                placeholder="First Name"
              />
            </div>
            <div className="enquiry-form-group">
              <label htmlFor="lastName">Last Name:</label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                placeholder="Last Name"
              />
            </div>
          </div>

          <div className="enquiry-form-group">
            <label htmlFor="whereAreYouBased">Where are you based:</label>
            <input
              type="text"
              id="whereAreYouBased"
              name="whereAreYouBased"
              value={formData.whereAreYouBased}
              onChange={handleChange}
              placeholder="(City and Country)"
            />
          </div>

          <div className="enquiry-form-group">
            <label htmlFor="email">Email (Please make sure your email is right)</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="This will be our main way to contact you."
              className={errors.email ? 'input-error' : ''}
              required
            />
            {errors.email && <span className="error-message" style={{ color: '#d32f2f', fontSize: '0.875rem', marginTop: '0.25rem', display: 'block' }}>{errors.email}</span>}
          </div>

          <div className="enquiry-form-group">
            <label htmlFor="whereDidYouFindMe">Where did you find me:</label>
            <select
              id="whereDidYouFindMe"
              name="whereDidYouFindMe"
              value={formData.whereDidYouFindMe}
              onChange={handleChange}
            >
              <option value="">Choose Option/s</option>
              <option value="google">Google Search</option>
              <option value="instagram">Instagram</option>
              <option value="facebook">Facebook</option>
              <option value="pinterest">Pinterest</option>
              <option value="referral">Referral</option>
              <option value="other">Other</option>
            </select>
          </div>

          <div className="enquiry-form-group">
            <label htmlFor="businessName">What's the name of your business:</label>
            <input
              type="text"
              id="businessName"
              name="businessName"
              value={formData.businessName}
              onChange={handleChange}
              placeholder="Business Name"
            />
          </div>

          <div className="enquiry-form-group">
            <label htmlFor="businessDescription">Describe your business in 2-3 sentences:</label>
            <p className="enquiry-form-instruction">What do you do, who is it for, and what makes it special?</p>
            <textarea
              id="businessDescription"
              name="businessDescription"
              value={formData.businessDescription}
              onChange={handleChange}
              rows={5}
              placeholder=""
            />
          </div>

          <div className="enquiry-form-group">
            <label htmlFor="whyWorkWithMe">Why do you want to work with me:</label>
            <p className="enquiry-form-instruction">Required</p>
            <textarea
              id="whyWorkWithMe"
              name="whyWorkWithMe"
              value={formData.whyWorkWithMe}
              onChange={handleChange}
              rows={5}
              required
              placeholder=""
            />
          </div>

          <div className="enquiry-form-group">
            <label htmlFor="estimatedBudget">What's your estimated budget:</label>
            <select
              id="estimatedBudget"
              name="estimatedBudget"
              value={formData.estimatedBudget}
              onChange={handleChange}
            >
              <option value="">Select</option>
              <option value="under-500">Under $500</option>
              <option value="500-1500">$500 - $1,500</option>
              <option value="1500-2500">$1,500 - $2,500</option>
              <option value="2500-plus">$2,500+</option>
            </select>
          </div>

          <div className="enquiry-form-group">
            <label htmlFor="projectDeadline">What's your ideal project deadline:</label>
            <input
              type="text"
              id="projectDeadline"
              name="projectDeadline"
              value={formData.projectDeadline}
              onChange={handleChange}
              placeholder="Would be nice to know"
            />
          </div>

          <button type="submit" className="enquiry-submit-button">SUBMIT</button>
        </form>
      </section>
    </div>
  )
}

export default ContactForm

